import { useState } from 'react';
import useZeroClearOnFocus from './useZeroClearOnFocus';

export default function useFieldDraft() {
  const { isCleared, focus: zeroFocus, release } = useZeroClearOnFocus();
  const [draft, setDraft] = useState(null);

  const fieldKey = (item, key) => `${item.uuid || item.id}:${key}`;

  const displayValue = (item, key, storedValue, format) => {
    if (isCleared(item, key)) return '';
    if (draft && draft.key === fieldKey(item, key)) return draft.value;
    return format(storedValue);
  };

  const handleFocus = (item, key, storedValue, enabled) => (event) => {
    setDraft(null);
    zeroFocus(item, key, storedValue, enabled)(event);
  };

  const handleBlur = (item, key) => {
    release(item, key);
    setDraft(null);
  };

  const handleInput = (item, key, storedValue, format, commit) => (event) => {
    const typed = event.target.value.replace(/[$,%\s]/g, '');
    if (typed === String(displayValue(item, key, storedValue, format))) return;
    setDraft({ key: fieldKey(item, key), value: typed });
    commit(typed);
  };

  return { isCleared, zeroFocus, release, displayValue, handleFocus, handleBlur, handleInput };
}
